import { Backdrop, Box, Popover, Stack } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";
import { COLOR_BLACK } from "../../data/colors/Colors";
import { ArrowBackIos } from "@mui/icons-material";

interface props {
  layout: ReactElement;
  anchorElPosition: { top: number; left: number } | null;
  transitionDuration?: number;
  minWidth?: string;
  width?: string | number;
  height?: string;
  onClose: () => void;
}

export function CustomPopoverView(props: props) {
  const handleClose = () => {
    props.onClose();
  };

  const open = Boolean(props.anchorElPosition);
  const id = open ? "popover" : undefined;

  return (
    <Backdrop
      open={open}
      sx={{ color: COLOR_BLACK, zIndex: (theme) => theme.zIndex.drawer + 3 }}
    >
      <Popover
        id={id}
        open={open}
        anchorPosition={props.anchorElPosition ?? { top: 0, left: 0 }}
        anchorReference={"anchorPosition"}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transitionDuration={props.transitionDuration}
        slotProps={{
          paper: {
            sx: {
              borderRadius: 6,
              width: props.width,
              height: props.height,
              minWidth: props.minWidth,
            },
          },
        }}
      >
        {props.layout}
      </Popover>
    </Backdrop>
  );
}
